import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-dark-alt py-24" data-id="element-54">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="bg-dark-card border border-dark-border rounded-2xl p-10 md:p-14 text-center relative overflow-hidden" data-id="element-56">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent to-transparent" data-id="element-57"></div>

          <ShieldCheck className="w-20 h-20 text-accent mx-auto mb-8" data-id="element-58" />

          <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-6 uppercase" data-id="element-59">
            Garantía de 30 días sin riesgo
          </h2>

          <p className="text-xl text-gray-400 leading-relaxed" data-id="element-60">
            Si lees el ebook completo, sigues todas las instrucciones y no
            sientes que valió la pena, te devolvemos cada centavo.{' '}
            <strong className="text-white" data-id="element-61">Sin preguntas.</strong>
          </p>
        </motion.div>
      </div>
    </section>;
}